import { Skeleton } from '@/shared/ui';

import generateSkeletonKeys from '@/shared/lib/format/generateSkeletonKeys';

const FEED_SKELETON_ROWS = 10;
const skeletonKeys = generateSkeletonKeys(FEED_SKELETON_ROWS);

export const FeedSkeleton = () => (
  <>
    {skeletonKeys.map(row => (
      <Skeleton
        key={row}
        height='23px'
        width='100%'
      />
    ))}
  </>
);
